import React, { Fragment, useEffect, useState } from "react";
import { pushNotify } from "../../../../services/NotifyService"
import { Axios, AxiosGet } from "../../../../context/UserContext"
import { ScaleLoader } from "react-spinners";
import ScheduleInfo from "./ScheduleInfo";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import Button from '@inovua/reactdatagrid-community/packages/Button';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import moment from "moment/moment";

function StatsTable() {
    const [isLoading, setIsLoading] = useState(false);
    const [scheduleData, setScheduleData] = useState(null);
    const [schedules,setSchedules]=useState([])
    const [showInfo, setShowInfo] = useState({ show: false, id: null })
    const [gridRef, setGridRef] = useState(null)
    const gridStyle = { height: 'calc(100vh - 16.5rem)', marginTop: 10 };
    window.moment = moment

    const fetchScheduleData = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosGet('fetch_schedules.php');
            console.log(data);
            if (data.success) {
                setScheduleData(data);
                setSchedules(data.schedules)
            }
            else pushNotify("error", "Error", data.error)
        }
        catch (err) {
            pushNotify("error", "Error", "Server Error!")
        }
        finally {
            setIsLoading(false)
        }
    }

    const filterValue = [
        { name: 'sl', operator: 'startsWith', type: 'string', value: '' },
        { name: 'title', operator: 'startsWith', type: 'string', value: '' },
        { name: 'city', operator: 'startsWith', type: 'string', value: '' },
        { name: 'call_sheet', operator: 'startsWith', type: 'string', value: '' },
        { name: 'shoot_date', operator: 'before', type: 'date', value: '' },
    ];

    const columns = [
        { name: 'sl', header: 'Sl', minWidth:150  },
        { name: 'title', defaultFlex: 2, header: 'Title', minWidth:150 },
        { name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date', filterEditor: DateFilter, minWidth:150  },
        { name: 'city', defaultFlex: 2, header: 'City' , minWidth:150 },
        { name: 'call_sheet', defaultFlex: 2, header: 'Call Sheet' , minWidth:150 },
        {
            name: 'id', header: 'actions', render:
                ({ value }) =>
                    <button class="btn btn-primary tp-btn sharp" onClick={() => { setShowInfo({ show: true, id: value }) }} >
                        <i class="fas fa-arrow-right"></i>
                    </button>
        }
    ];

    const exportCSV = () => {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(',');
        const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(','));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

        downloadBlob(blob);
    };

    const downloadBlob = (blob, fileName = 'grid-data.csv') => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.position = 'absolute';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchScheduleData()
    }, [])

    return (
        <Fragment>

            {showInfo.show ? <ScheduleInfo showInfo={showInfo} setShowInfo={setShowInfo}></ScheduleInfo> :
                <>
                    <Button onClick={() => fetchScheduleData()}>
                        Sync Data
                    </Button>
                    <Button style={{ marginLeft: 10 }} onClick={exportCSV}>
                        Export CSV
                    </Button>
                    <ReactDataGrid
                        style={gridStyle}
                        columns={columns}
                        pagination="local"
                        dataSource={schedules}
                        defaultLimit={25}
                        defaultFilterValue={filterValue}
                        handle={setGridRef}
                        loading={isLoading}
                    />
                </>
                // <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
                //     <div className="card">
                //         <div className="card-header border-0 pb-0">
                //             <h4 className="card-title">Schedules<button className='btn btn-refresh' onClick={fetchScheduleData}><i class="fas fa-sync-alt"></i></button></h4>
                //         </div>
                //         <div className="card-body" style={{ "height": "calc(100vh - 20rem)" }}>
                //             <div className="table-responsive recentOrderTable" style={{ height: "100%" }}>
                //                 {
                //                     (scheduleData == null || isLoading) ?
                //                         <div className="row mx-0" style={{ height: "100%" }}><ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /></div>
                //                         : (
                //                             <table className="table verticle-middle table-responsive-md">
                //                                 <thead>
                //                                     <tr>
                //                                         <th scope="col">Title</th>
                //                                         <th scope="col">Shoot Date</th>
                //                                         <th scope="col">City</th>
                //                                         <th scope="col">Call Sheet</th>
                //                                         <th scope="col">Actions</th>
                //                                     </tr>
                //                                 </thead>
                //                                 <tbody>
                //                                     {scheduleData.schedules.map(schedule => (
                //                                         <tr key={schedule.sl}>
                //                                             <td>{schedule.title}</td>
                //                                             <td>{schedule.shoot_date}</td>
                //                                             <td>{schedule.city}</td>
                //                                             <td>{schedule.call_sheet}</td>
                //                                             <td>
                //                                                 <button class="btn btn-primary tp-btn sharp" onClick={() => { setShowInfo({ show: true, id: schedule.sl }) }} ><i class="fas fa-arrow-right"></i></button>
                //                                             </td>
                //                                         </tr>
                //                                     ))}

                //                                 </tbody>
                //                             </table>

                //                         )
                //                 }

                //             </div>
                //         </div>
                //     </div>
                // </div>
            }
        </Fragment>
    );
}
export default StatsTable;